import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _11e0442e = () => interopDefault(import('../../../pages/licensed-trainers.vue' /* webpackChunkName: "pages/licensed-trainers" */))
const _65407a9c = () => interopDefault(import('../../../pages/login/index.vue' /* webpackChunkName: "pages/login/index" */))
const _01743079 = () => interopDefault(import('../../../pages/my-account/index.vue' /* webpackChunkName: "pages/my-account/index" */))
const _95706cb4 = () => interopDefault(import('../../../pages/my-studios.vue' /* webpackChunkName: "pages/my-studios" */))
const _ccdd5036 = () => interopDefault(import('../../../pages/my-trainers.vue' /* webpackChunkName: "pages/my-trainers" */))
const _48ec76c8 = () => interopDefault(import('../../../pages/vimeo-test-7dj52nxv0f4sk.vue' /* webpackChunkName: "pages/vimeo-test-7dj52nxv0f4sk" */))
const _92077f36 = () => interopDefault(import('../../../pages/login/forgot-password.vue' /* webpackChunkName: "pages/login/forgot-password" */))
const _4d5f3829 = () => interopDefault(import('../../../pages/login/reset-password.vue' /* webpackChunkName: "pages/login/reset-password" */))
const _0547af50 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _42c630ae = () => interopDefault(import('../../../pages/deleted/_type.vue' /* webpackChunkName: "pages/deleted/_type" */))
const _e91ed76c = () => interopDefault(import('~/plugins/Cruxtify/pages/single.vue' /* webpackChunkName: "" */))
const _25340fc0 = () => interopDefault(import('~/plugins/Cruxtify/pages/list.vue' /* webpackChunkName: "" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/licensed-trainers",
    component: _11e0442e,
    name: "licensed-trainers"
  }, {
    path: "/login",
    component: _65407a9c,
    name: "login"
  }, {
    path: "/my-account",
    component: _01743079,
    name: "my-account"
  }, {
    path: "/my-studios",
    component: _95706cb4,
    name: "my-studios"
  }, {
    path: "/my-trainers",
    component: _ccdd5036,
    name: "my-trainers"
  }, {
    path: "/vimeo-test-7dj52nxv0f4sk",
    component: _48ec76c8,
    name: "vimeo-test-7dj52nxv0f4sk"
  }, {
    path: "/login/forgot-password",
    component: _92077f36,
    name: "login-forgot-password"
  }, {
    path: "/login/reset-password",
    component: _4d5f3829,
    name: "login-reset-password"
  }, {
    path: "/",
    component: _0547af50,
    name: "index"
  }, {
    path: "/deleted/:type?",
    component: _42c630ae,
    name: "deleted-type"
  }, {
    path: "/completed-courses/:id",
    component: _e91ed76c,
    meta: {"modelType":"CompletedCourse"},
    name: "CompletedCourse edit"
  }, {
    path: "/completed-courses",
    component: _25340fc0,
    meta: {"modelName":"CompletedCourse","modelType":"CompletedCourse"},
    name: "CompletedCourse list"
  }, {
    path: "/contracts/:id",
    component: _e91ed76c,
    meta: {"modelType":"Contract"},
    name: "Contract edit"
  }, {
    path: "/contracts",
    component: _25340fc0,
    meta: {"modelName":"Contract","modelType":"Contract"},
    name: "Contract list"
  }, {
    path: "/contract-events/:id",
    component: _e91ed76c,
    meta: {"modelType":"ContractEvent"},
    name: "ContractEvent edit"
  }, {
    path: "/contract-events",
    component: _25340fc0,
    meta: {"modelName":"ContractEvent","modelType":"ContractEvent"},
    name: "ContractEvent list"
  }, {
    path: "/contract-types/:id",
    component: _e91ed76c,
    meta: {"modelType":"ContractType"},
    name: "ContractType edit"
  }, {
    path: "/contract-types",
    component: _25340fc0,
    meta: {"modelName":"ContractType","modelType":"ContractType"},
    name: "ContractType list"
  }, {
    path: "/contract-type-countries/:id",
    component: _e91ed76c,
    meta: {"modelType":"ContractTypeCountry"},
    name: "ContractTypeCountry edit"
  }, {
    path: "/contract-type-countries",
    component: _25340fc0,
    meta: {"modelName":"ContractTypeCountry","modelType":"ContractTypeCountry"},
    name: "ContractTypeCountry list"
  }, {
    path: "/countries/:id",
    component: _e91ed76c,
    meta: {"modelType":"Country"},
    name: "Country edit"
  }, {
    path: "/countries",
    component: _25340fc0,
    meta: {"modelName":"Country","modelType":"Country"},
    name: "Country list"
  }, {
    path: "/country-accessible-resources/:id",
    component: _e91ed76c,
    meta: {"modelType":"CountryAccessibleResource"},
    name: "CountryAccessibleResource edit"
  }, {
    path: "/country-accessible-resources",
    component: _25340fc0,
    meta: {"modelName":"CountryAccessibleResource","modelType":"CountryAccessibleResource"},
    name: "CountryAccessibleResource list"
  }, {
    path: "/country-tags/:id",
    component: _e91ed76c,
    meta: {"modelType":"CountryTag"},
    name: "CountryTag edit"
  }, {
    path: "/country-tags",
    component: _25340fc0,
    meta: {"modelName":"CountryTag","modelType":"CountryTag"},
    name: "CountryTag list"
  }, {
    path: "/courses/:id",
    component: _e91ed76c,
    meta: {"modelType":"Course"},
    name: "Course edit"
  }, {
    path: "/courses",
    component: _25340fc0,
    meta: {"modelName":"Course","modelType":"Course"},
    name: "Course list"
  }, {
    path: "/course-accessible-resources/:id",
    component: _e91ed76c,
    meta: {"modelType":"CourseAccessibleResource"},
    name: "CourseAccessibleResource edit"
  }, {
    path: "/course-accessible-resources",
    component: _25340fc0,
    meta: {"modelName":"CourseAccessibleResource","modelType":"CourseAccessibleResource"},
    name: "CourseAccessibleResource list"
  }, {
    path: "/course-categories/:id",
    component: _e91ed76c,
    meta: {"modelType":"CourseCategory"},
    name: "CourseCategory edit"
  }, {
    path: "/course-categories",
    component: _25340fc0,
    meta: {"modelName":"CourseCategory","modelType":"CourseCategory"},
    name: "CourseCategory list"
  }, {
    path: "/course-costs/:id",
    component: _e91ed76c,
    meta: {"modelType":"CourseCost"},
    name: "CourseCost edit"
  }, {
    path: "/course-costs",
    component: _25340fc0,
    meta: {"modelName":"CourseCost","modelType":"CourseCost"},
    name: "CourseCost list"
  }, {
    path: "/course-tags/:id",
    component: _e91ed76c,
    meta: {"modelType":"CourseTag"},
    name: "CourseTag edit"
  }, {
    path: "/course-tags",
    component: _25340fc0,
    meta: {"modelName":"CourseTag","modelType":"CourseTag"},
    name: "CourseTag list"
  }, {
    path: "/equipment/:id",
    component: _e91ed76c,
    meta: {"modelType":"Equipment"},
    name: "Equipment edit"
  }, {
    path: "/equipment",
    component: _25340fc0,
    meta: {"modelName":"Equipment","modelType":"Equipment"},
    name: "Equipment list"
  }, {
    path: "/events/:id",
    component: _e91ed76c,
    meta: {"modelType":"Event"},
    name: "Event edit"
  }, {
    path: "/events",
    component: _25340fc0,
    meta: {"modelName":"Event","modelType":"Event"},
    name: "Event list"
  }, {
    path: "/languages/:id",
    component: _e91ed76c,
    meta: {"modelType":"Language"},
    name: "Language edit"
  }, {
    path: "/languages",
    component: _25340fc0,
    meta: {"modelName":"Language","modelType":"Language"},
    name: "Language list"
  }, {
    path: "/mailer-events/:id",
    component: _e91ed76c,
    meta: {"modelType":"MailerEvent"},
    name: "MailerEvent edit"
  }, {
    path: "/mailer-events",
    component: _25340fc0,
    meta: {"modelName":"MailerEvent","modelType":"MailerEvent"},
    name: "MailerEvent list"
  }, {
    path: "/mailer-templates/:id",
    component: _e91ed76c,
    meta: {"modelType":"MailerTemplate"},
    name: "MailerTemplate edit"
  }, {
    path: "/mailer-templates",
    component: _25340fc0,
    meta: {"modelName":"MailerTemplate","modelType":"MailerTemplate"},
    name: "MailerTemplate list"
  }, {
    path: "/notes/:id",
    component: _e91ed76c,
    meta: {"modelType":"Note"},
    name: "Note edit"
  }, {
    path: "/notes",
    component: _25340fc0,
    meta: {"modelName":"Note","modelType":"Note"},
    name: "Note list"
  }, {
    path: "/notifications/:id",
    component: _e91ed76c,
    meta: {"modelType":"Notification"},
    name: "Notification edit"
  }, {
    path: "/notifications",
    component: _25340fc0,
    meta: {"modelName":"Notification","modelType":"Notification"},
    name: "Notification list"
  }, {
    path: "/virtual-classes/:id",
    component: _e91ed76c,
    meta: {"modelType":"PublicClass"},
    name: "PublicClass edit"
  }, {
    path: "/virtual-classes",
    component: _25340fc0,
    meta: {"modelName":"PublicClass","modelType":"PublicClass"},
    name: "PublicClass list"
  }, {
    path: "/qualifications/:id",
    component: _e91ed76c,
    meta: {"modelType":"Qualification"},
    name: "Qualification edit"
  }, {
    path: "/qualifications",
    component: _25340fc0,
    meta: {"modelName":"Qualification","modelType":"Qualification"},
    name: "Qualification list"
  }, {
    path: "/resources/:id",
    component: _e91ed76c,
    meta: {"modelType":"Resource"},
    name: "Resource edit"
  }, {
    path: "/resources",
    component: _25340fc0,
    meta: {"modelName":"Resource","modelType":"Resource"},
    name: "Resource list"
  }, {
    path: "/resource-types/:id",
    component: _e91ed76c,
    meta: {"modelType":"ResourceType"},
    name: "ResourceType edit"
  }, {
    path: "/resource-types",
    component: _25340fc0,
    meta: {"modelName":"ResourceType","modelType":"ResourceType"},
    name: "ResourceType list"
  }, {
    path: "/studios/:id",
    component: _e91ed76c,
    meta: {"modelType":"Studio"},
    name: "Studio edit"
  }, {
    path: "/studios",
    component: _25340fc0,
    meta: {"modelName":"Studio","modelType":"Studio"},
    name: "Studio list"
  }, {
    path: "/studio-equipment/:id",
    component: _e91ed76c,
    meta: {"modelType":"StudioEquipment"},
    name: "StudioEquipment edit"
  }, {
    path: "/studio-equipment",
    component: _25340fc0,
    meta: {"modelName":"StudioEquipment","modelType":"StudioEquipment"},
    name: "StudioEquipment list"
  }, {
    path: "/studio-tags/:id",
    component: _e91ed76c,
    meta: {"modelType":"StudioTag"},
    name: "StudioTag edit"
  }, {
    path: "/studio-tags",
    component: _25340fc0,
    meta: {"modelName":"StudioTag","modelType":"StudioTag"},
    name: "StudioTag list"
  }, {
    path: "/survey-responses/:id",
    component: _e91ed76c,
    meta: {"modelType":"SurveyResponse"},
    name: "SurveyResponse edit"
  }, {
    path: "/survey-responses",
    component: _25340fc0,
    meta: {"modelName":"SurveyResponse","modelType":"SurveyResponse"},
    name: "SurveyResponse list"
  }, {
    path: "/trainers/:id",
    component: _e91ed76c,
    meta: {"modelType":"Trainer"},
    name: "Trainer edit"
  }, {
    path: "/trainers",
    component: _25340fc0,
    meta: {"modelName":"Trainer","modelType":"Trainer"},
    name: "Trainer list"
  }, {
    path: "/trainer-qualifications/:id",
    component: _e91ed76c,
    meta: {"modelType":"TrainerQualification"},
    name: "TrainerQualification edit"
  }, {
    path: "/trainer-qualifications",
    component: _25340fc0,
    meta: {"modelName":"TrainerQualification","modelType":"TrainerQualification"},
    name: "TrainerQualification list"
  }, {
    path: "/trainer-tags/:id",
    component: _e91ed76c,
    meta: {"modelType":"TrainerTag"},
    name: "TrainerTag edit"
  }, {
    path: "/trainer-tags",
    component: _25340fc0,
    meta: {"modelName":"TrainerTag","modelType":"TrainerTag"},
    name: "TrainerTag list"
  }, {
    path: "/users/:id",
    component: _e91ed76c,
    meta: {"modelType":"User"},
    name: "User edit"
  }, {
    path: "/users",
    component: _25340fc0,
    meta: {"modelName":"User","modelType":"User"},
    name: "User list"
  }, {
    path: "/user-tags/:id",
    component: _e91ed76c,
    meta: {"modelType":"UserTag"},
    name: "UserTag edit"
  }, {
    path: "/user-tags",
    component: _25340fc0,
    meta: {"modelName":"UserTag","modelType":"UserTag"},
    name: "UserTag list"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
